import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { IMG } from "@/data/content";

export default function Story() {
  return (
    <section data-testid="story-section" className="section-pad">
      <div className="max-w-7xl mx-auto container-px grid lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-6 relative"
        >
          <div className="relative rounded-3xl overflow-hidden border border-border">
            <img src={IMG.doughKneading} alt="Aluat lucrat manual" className="w-full h-[560px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 text-white">
              <p className="font-display italic text-2xl leading-snug">
                &bdquo;În Beclean, aluatul nu se grăbește. Se lasă lucrat cum trebuie.&rdquo;
              </p>
            </div>
          </div>
          <div className="hidden md:block absolute -bottom-8 -right-8 h-32 w-32 rounded-2xl border border-gold/30 bg-bg flex items-center justify-center" style={{ display: 'flex' }}>
            <div className="text-center">
              <div className="font-display text-4xl text-gold">2019</div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-text-soft mt-1">An de înființare</div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="lg:col-span-6"
        >
          <p className="eyebrow mb-4">Povestea DOTAPAN</p>
          <h2 className="h-display text-3xl md:text-5xl text-text">
            O meserie veche, <em className="text-gold not-italic">dusă mai departe</em> cu mândrie.
          </h2>
          <div className="mt-7 space-y-5 text-base md:text-lg text-text-soft leading-relaxed">
            <p>
              DOTAPAN s-a născut în Beclean, într-un loc unde pâinea, aluatul și cuptorul au încă răbdare. Aici, meseria nu se face din vorbe mari.
              Se face din mâini muncite, rețete încercate, ingrediente bune și respect pentru client.
            </p>
            <p>
              Nu vrem să părem mai mari decât suntem. Vrem să fim mai buni în ceea ce facem. Fiecare blat, fiecare croissant, fiecare foietaj,
              fiecare fursec și fiecare saleu poartă în el grijă, rutină bună și pricepere.
            </p>
            <p className="text-text">
              Pentru noi, panificația nu este doar producție. Este promisiunea că afacerea ta primește produse pe care se poate baza.
            </p>
          </div>

          <div className="mt-8 flex items-start gap-4 p-5 rounded-2xl border border-gold/30 bg-surface">
            <Quote className="h-6 w-6 text-gold shrink-0" />
            <p className="font-display italic text-lg text-text">
              &bdquo;La DOTAPAN, meseria se simte în fiecare strat de aluat.&rdquo;
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
